
define('text!modules/reporting/segments/dataExport/createEdit/templates/date-field.html',[],function () { return '<strand-header class="date-field-header" size="small">Reporting Date</strand-header>\n<div class="date-field-value">\n    <span class="as-of-holder">As of </span>\n    <span class="reporting-date">{{reporting-date}}</span>\n</div>';});

